import { CustomerMethodologyPage } from "../../components/CustomerMethodologyPage";

export function DdiMethodologyPage() {
  return (
    <CustomerMethodologyPage
      title="Drug interaction reference — overview"
      description="How WeConsult Rx surfaces drug-drug interactions as an educational reference for consultant pharmacists."
      path="/trust/ddi-methodology"
    >
      <p>
        WeConsult Rx surfaces drug-drug interaction (DDI) information as an{" "}
        <strong>educational reference</strong>. It is{" "}
        <strong>not clinical decision support</strong>, not medical advice, and
        is not a substitute for clinical judgment or the prescribing information
        itself.
      </p>
      <h2>What you get</h2>
      <ul>
        <li>Interaction information sourced from FDA-approved drug labeling.</li>
        <li>Standardized drug naming for consistent pair lookups.</li>
        <li>Verbatim quotes from the label so you can verify the source.</li>
      </ul>
      <h2>How it helps your workflow</h2>
      <p>
        During chart review, flagged interactions appear alongside the resident&apos;s
        medication list so the consultant pharmacist can accept, dismiss, or
        document a clinical decision — with the citation attached.
      </p>
    </CustomerMethodologyPage>
  );
}
